// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_financialSection__k22En {
  background-color: var(--background-color0);
  padding: 6rem 0;
}

.styles_sectionTitle__adxcL {
  font-size: 2.2rem;
  font-weight: 700;
  text-align: center;
  color: var(--text-color0);
  margin-bottom: 1rem;
}

.styles_divider__DEBzs {
  width: 5rem;
  height: 4px;
  background-color: var(--brand-yellow);
  border: none;
  border-radius: 2px;
  margin: 1.5rem auto 3.5rem auto;
}

.styles_tableWrapper__xZv4t {
  width: 100%;
  overflow-x: auto;
  border-radius: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  background-color: var(--background-color1);
}

.styles_financialTable__OEiOJ {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  min-width: 650px;
}

.styles_tableTh__17UQ5 {
  background-color: rgba(var(--brand-yellow-rgb), 0.1);
  color: var(--brand-yellow);
  font-weight: 700;
  font-size: 1.1rem;
  padding: 1.25rem 1.5rem;
  border-bottom: 2px solid rgba(var(--brand-yellow-rgb), 0.2);
}

.styles_tableTr__bIYhr {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: background-color 0.2s ease;
}

.styles_tableTr__bIYhr:hover {
  background-color: rgba(255, 255, 255, 0.02);
}

.styles_tableTd__5-2FT {
  padding: 1.25rem 1.5rem;
  color: var(--text-color1);
  font-size: 1rem;
  line-height: 1.6;
}

.styles_tableTdHighlight__M0WfS {
  padding: 1.25rem 1.5rem;
  color: var(--text-color0);
  font-weight: 700;
  font-size: 1.05rem;
}

.styles_highlight__EeDjS {
  color: var(--brand-yellow);
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/CadastroLoja/components/FinancialSection/styles.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,2DAA2D;AAC7D;;AAEA;EACE,kDAAkD;EAClD,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".financialSection {\n  background-color: var(--background-color0);\n  padding: 6rem 0;\n}\n\n.sectionTitle {\n  font-size: 2.2rem;\n  font-weight: 700;\n  text-align: center;\n  color: var(--text-color0);\n  margin-bottom: 1rem;\n}\n\n.divider {\n  width: 5rem;\n  height: 4px;\n  background-color: var(--brand-yellow);\n  border: none;\n  border-radius: 2px;\n  margin: 1.5rem auto 3.5rem auto;\n}\n\n.tableWrapper {\n  width: 100%;\n  overflow-x: auto;\n  border-radius: 1rem;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n  background-color: var(--background-color1);\n}\n\n.financialTable {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n  min-width: 650px;\n}\n\n.tableTh {\n  background-color: rgba(var(--brand-yellow-rgb), 0.1);\n  color: var(--brand-yellow);\n  font-weight: 700;\n  font-size: 1.1rem;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 2px solid rgba(var(--brand-yellow-rgb), 0.2);\n}\n\n.tableTr {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  transition: background-color 0.2s ease;\n}\n\n.tableTr:hover {\n  background-color: rgba(255, 255, 255, 0.02);\n}\n\n.tableTd {\n  padding: 1.25rem 1.5rem;\n  color: var(--text-color1);\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n.tableTdHighlight {\n  padding: 1.25rem 1.5rem;\n  color: var(--text-color0);\n  font-weight: 700;\n  font-size: 1.05rem;\n}\n\n.highlight {\n  color: var(--brand-yellow);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"financialSection": `styles_financialSection__k22En`,
	"sectionTitle": `styles_sectionTitle__adxcL`,
	"divider": `styles_divider__DEBzs`,
	"tableWrapper": `styles_tableWrapper__xZv4t`,
	"financialTable": `styles_financialTable__OEiOJ`,
	"tableTh": `styles_tableTh__17UQ5`,
	"tableTr": `styles_tableTr__bIYhr`,
	"tableTd": `styles_tableTd__5-2FT`,
	"tableTdHighlight": `styles_tableTdHighlight__M0WfS`,
	"highlight": `styles_highlight__EeDjS`
};
export default ___CSS_LOADER_EXPORT___;
